import React, { useState } from 'react';

import { useAccount } from 'wagmi';

import ModalWithFullScreenBg from '@/shared/components/ui/Modal/ModalWithFullScreenBg';
import SecondaryBtn from '@/shared/components/ui/SecondaryBtn/SecondaryBtn';

import bonuses from 'assets/png/bonuses-desktop.png';
import ShareIcon from 'assets/share.svg?react';

const ShareGameModal = ({
  open,
  setOpen,
  isMobile,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  isMobile?: boolean;
}) => {
  const { address } = useAccount();
  const [showToast, setShowToast] = useState(false);

  const handleShareClick = async () => {
    const currentUrl = window.location.href;
    const streamUrl = `${currentUrl.replace('room', 'stream')}?ref=${address}`;

    if (isMobile && navigator.share) {
      try {
        await navigator.share({
          title: 'Game Replay',
          text: 'Check out this game replay!',
          url: streamUrl,
        });
      } catch (error) {
        // If sharing is cancelled or fails, fall back to clipboard
        await navigator.clipboard.writeText(streamUrl);
      }
    } else {
      await navigator.clipboard.writeText(streamUrl);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 1000);
    }
  };

  return (
    <ModalWithFullScreenBg
      open={open}
      className="bg-background bg-opacity-50"
      childrenClassName="bg-share-game-modal-border p-[2px]"
    >
      <div className="bg-share-game-modal-gradient w-full h-full rounded-3xl">
        <div className="flex flex-col p-4 sm:px-6 sm:py-6 sm:pt-8">
          <img
            src={bonuses}
            alt="bonuses"
            className="w-[120px] h-[100px] sm:w-[360px] sm:h-[300px] self-center"
          />
          <h3 className="mb-5 sm:my-6 font-poppins text-[16px] sm:text-[36px] font-bold leading-[20px] sm:leading-[44px] bg-gradient-to-r from-[#FFF] to-[#FFC000] bg-clip-text text-transparent">
            Share Game Replay!
          </h3>
          <p className="font-poppins text-[10px] sm:text-[20px] font-normal leading-[12px] sm:leading-[24px] text-[#F7F7F7]">
            Share your game replay with friends and earn exclusive rewards! Every time a new player
            joins through your shared replay link, you receive a referral bonus.
          </p>
          <div className="bg-[#272D63] w-full h-[2px] my-3 sm:my-6"></div>
          <p className="font-poppins text-[9px] sm:text-[16px] font-normal leading-[12px] sm:leading-[20px] text-[#C0C0FF] mb-6">
            Start sharing now and build your gaming network! 🚀
          </p>
          <SecondaryBtn onClick={handleShareClick} text="Share Game" svg={<ShareIcon />} />
          <button
            onClick={() => setOpen(false)}
            className="font-poppins text-[10px] sm:text-[16px] font-normal leading-[12px] sm:leading-[20px] text-[#C0C0FF] mt-6"
          >
            No, thanks
          </button>

          {/* Toast Notification */}
          <div
            className={`fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-[#272D63] text-white px-6 py-3 rounded-lg font-poppins text-[16px] transition-opacity duration-300 ${showToast ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
          >
            Link copied
          </div>
        </div>
      </div>
    </ModalWithFullScreenBg>
  );
};

export default ShareGameModal;
